// IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3: «параметры в форме-меню»): ПУНКТ-ПАРАМЕТР формы-меню (components/MenuPanel.vue) — флажок или выпадающий список
// прямо в строке панели; значение применяется сразу, панель остаётся открытой. Чистые функции (без Vue и без стора) — юнит-тест tests/unit/menuParams.test.mjs.
//
// Контракт пункта (поля пункта как раньше — command / method / attrs … — остаются для wj-menu, мобильного профиля и выключенного флага):
//   { title, _key, cssClass, …,
//     param: {
//       type: 'check' | 'select',
//       value: () => any,                 // геттер: читается внутри computed view панели → живое обновление; не функция: check → raw.active, select → литерал
//       options: () => [{ id, title }],   // select: функция или массив
//       command: 'setLanguage',           // необязательно: команда действия, если у пункта своей нет (папка с радио-детьми)
//       field: 'language',                // поле действия, куда кладётся выбранное значение (по умолчанию 'value')
//     } }
// Выбор → событие панели pick(menuParam_action(raw, v), { target, keepOpen: true }): владельцы исполняют его тем же путём, что и пункт
// (executeStoreMethod), новых команд стора нет. Выключатель — настройка базы fe.ux.menuPanelParams (по умолчанию вкл.; false — пункт рисуется как раньше:
// папка с радио-детьми или пункт-ссылка с active).

export const MENU_PARAMS_FLAG = 'fe.ux.menuPanelParams'
export const MENU_PARAM_TYPES = ['check', 'select']
// select: Chrome / Windows шлёт change на каждый шаг стрелок в закрытом списке, а смена языка — полный relocalize; применяется последнее значение
// после паузы (настройка базы fe.ux.menuPanelParamDelayMs; 0 — сразу). Флажок применяется сразу
export const MENU_PARAM_DELAY_KEY = 'fe.ux.menuPanelParamDelayMs'
export const MENU_PARAM_DELAY_MS = 250

// механизм включён: стор (настройка fe.ux.menuPanelParams, выключено только явным false) либо уже посчитанный признак (boolean); без стора — вкл.
export function menuParams_on(store) {
    if (typeof store === 'boolean') return store
    try { return !(store && typeof store.setting === 'function' && store.setting(MENU_PARAMS_FLAG, true) === false) } catch (e) { return true }
}

// пауза применения select (мс): настройка базы, неверное значение — умолчание
export function menuParam_delay(store) {
    let v = MENU_PARAM_DELAY_MS
    try { if (store && typeof store.setting === 'function') v = Number(store.setting(MENU_PARAM_DELAY_KEY, MENU_PARAM_DELAY_MS)) } catch (e) { v = MENU_PARAM_DELAY_MS }
    return (Number.isFinite(v) && v >= 0) ? Math.round(v) : MENU_PARAM_DELAY_MS
}

// у пункта есть параметр известного вида (флаг не учитывается)
export function menuParam_has(raw) {
    const p = raw && raw.param
    return !!(p && typeof p === 'object' && MENU_PARAM_TYPES.includes(p.type))
}

const call = (f) => { try { return f() } catch (e) { return undefined } }
const keyOf = (v) => (v === undefined || v === null) ? '' : String(v)

// параметр пункта для отрисовки: { type, value, valueKey, valueTitle, options: [{ id, key, title }], command, field } либо null (параметра нет / механизм выключен).
// key — строка значения для <select> / <option> (DOM отдаёт строки; обратно — menuParam_fromDom); valueTitle — подпись текущей опции (у флажка пусто)
export function menuParam_norm(raw, store) {
    if (!menuParam_has(raw) || !menuParams_on(store)) return null
    const p = raw.param, type = p.type
    let value = typeof p.value === 'function' ? call(p.value) : p.value
    if (type === 'check') {
        if (value === undefined && typeof p.value !== 'function') value = raw.active === true
        return { type, value: !!value, valueKey: value ? '1' : '', valueTitle: '', options: [], command: p.command || '', field: p.field || 'value' }
    }
    const list = typeof p.options === 'function' ? call(p.options) : p.options
    const options = []
    const seen = new Set()
    for (const o of (Array.isArray(list) ? list : [])) {
        if (!o || o.id === undefined || o.id === null) continue
        const key = keyOf(o.id)
        if (seen.has(key)) continue
        seen.add(key)
        options.push({ id: o.id, key, title: String(o.title ?? o.id) })
    }
    const valueKey = keyOf(value)
    const cur = options.find(o => o.key === valueKey)
    return { type, value, valueKey, valueTitle: cur ? cur.title : '', options, command: p.command || '', field: p.field || 'value' }
}

// значение из DOM (строка <select> / флажок) → значение параметра: у select — id опции с этой строкой (числовые id остаются числами), у флажка — boolean
export function menuParam_fromDom(norm, v) {
    if (!norm) return v
    if (norm.type === 'check') return !!v
    const o = (norm.options || []).find(x => x.key === keyOf(v))
    return o ? o.id : v
}

// действие выбора: с param.command — { command, [field]: v } (папка с радио-детьми команды не несёт: wj-menu выполнил бы её без значения);
// иначе — сам пункт без param с полем значения. Пункт не меняется
export function menuParam_action(raw, v) {
    const p = (raw && raw.param) || {}
    const field = p.field || 'value'
    if (p.command) return { command: p.command, [field]: v }
    const out = { ...(raw || {}) }
    delete out.param
    out[field] = v
    return out
}

// подписи опций для поиска: текущая первой, затем остальные (без повторов и пустых); у флажка — нет
export function menuParam_optionTexts(norm) {
    if (!norm || norm.type !== 'select') return []
    const out = []
    const add = (s) => { const x = String(s || '').trim(); if (x && !out.includes(x)) out.push(x) }
    add(norm.valueTitle)
    for (const o of norm.options || []) add(o.title)
    return out
}

// строка корпуса поиска панели: у select — ячейки [название, текущая опция, …прочие опции] (как у пункта с бейджем: «Русский» / «Стиль 2o» находят пункт);
// у флажка и без опций — название, как у обычного пункта
export function menuParam_cells(title, norm) {
    const opts = menuParam_optionTexts(norm)
    return opts.length ? [String(title || ''), ...opts] : String(title || '')
}
